import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type OverviewStatsBoxesProps = {
  boxOneTitle: string;
  boxOneValue: string;
  boxTwoTitle?: string;
  boxTwoValue?: string;
};

export const OverviewStatsBoxes = ({ boxOneTitle, boxOneValue, boxTwoTitle, boxTwoValue }: OverviewStatsBoxesProps) => {
  return (
    <Stack
      direction="row"
      spacing={4}
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 4,
      }}
    >
      <Box
        data-test={`box-${boxOneTitle}`}
        sx={{
          border: 1,
          borderColor: 'divider',
          padding: 3,
          width: '100%',
          backgroundColor: 'background.boxLight',
        }}
      >
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {boxOneTitle}
        </Typography>
        <Typography variant="h1">{boxOneValue}</Typography>
      </Box>
      {boxTwoTitle && boxTwoValue && (
        <Box
          data-test={`box-${boxTwoTitle}`}
          sx={{
            border: 1,
            borderColor: 'divider',
            padding: 3,
            width: '100%',
            backgroundColor: 'background.boxLight',
          }}
        >
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {boxTwoTitle}
          </Typography>
          <Typography variant="h1">{boxTwoValue}</Typography>
        </Box>
      )}
    </Stack>
  );
};
